import { ComponentRoute } from '@/classes'

const SubJobStageRoutes = {
  SubJobStageListView: new ComponentRoute('/subJobStage', 'SubJobStageListView'),
  SubJobStageView: new ComponentRoute('/subJobStage/:companySubJobStageId', 'SubJobStageView'),
  SubJobStageDetail: new ComponentRoute('/subJobStage/:companySubJobStageId', 'SubJobStageDetail')
}

export default SubJobStageRoutes
